import { useCallback, useRef } from 'react';

export const useCarousel = (containerRef: React.RefObject<HTMLDivElement>) => {
  const animationRef = useRef<number>();

  const startCarousel = useCallback(() => {
    if (!containerRef.current) return;

    const scroll = () => {
      if (!containerRef.current) return;
      
      containerRef.current.scrollLeft += 1;
      
      if (
        containerRef.current.scrollLeft >=
        containerRef.current.scrollWidth / 2
      ) {
        containerRef.current.scrollLeft = 0;
      }
      
      animationRef.current = requestAnimationFrame(scroll);
    };

    animationRef.current = requestAnimationFrame(scroll);
  }, []);

  const stopCarousel = useCallback(() => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }
  }, []);

  return { startCarousel, stopCarousel };
};